import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, ViewEncapsulation, ElementRef, Inject, OnInit, OnDestroy } from '@angular/core';
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { DialogSuccessBuyComponent } from '../dialog-success-buy/dialog-success-buy.component';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { DialogActionConfirmation } from './dialog-action-confirmation.model';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { Subscription } from 'rxjs/Subscription';
import { AuthorizationWraperService } from '@toro/common/shared/services/authorization-wraper/authorization.wraper.service';
import { ApplicationMessagesAction } from '@toro/common/shared/state-management/application-messages/application-message.action';
import { StockOrderType } from '@toro/common/shared/models/stocks-exchange/stock-order.model';
import { StrategyRequestLegPriceType } from '@toro/common/shared/models/stocks-exchange/strategy-request-leg-price-type.enum';
import { StrategyRequestLegValidityType } from '@toro/common/shared/models/stocks-exchange/strategy-request-leg-validity-type.enum';
import { StrategyRequestOrderType } from '@toro/common/shared/models/stocks-exchange/strategy-request-order-type.enum';
import { StocksExchangeCheckoutAction } from '../../../../state-management/stocks-exchange-checkout/stocks-exchange-checkout.action';
import { StocksExchangeCheckoutEffects } from '../../../../state-management/stocks-exchange-checkout/stocks-exchange-checkout.effects';
import { OrderSideEnum } from '@toro/common/shared/enum/orders/side.enum';
import { StocksMarketInteractionsService } from '../../services/stocks-market-interactions.service';
import { BillingAction } from '../../../../state-management/billing/billing.action';
import { BrokeragePlatform } from '@toro/common/shared/enum/billing/brokerage-platform.enum';
import { InvestmentResumeComponent } from '../../checkout/dialogs/investment-resume/investment-resume.component';
import { BillingEffects } from '../../../../state-management/billing/billing.effects';
import { CheckoutScenarioSettings } from '../../checkout/checkout-scenario.settings';
import { ToastrService } from 'ngx-toastr';
import { OrderSentEvent } from '@toro/common/shared/models/segment/order-sent-event.model';
import { SegmentCheckoutTypeEnum } from '@toro/common/shared/enum/segment/segment-checkout-type.enum';
import { TrackOriginEnum } from '@toro/common/shared/enum/segment/segment-origin.enum';
import { SegmentOrderSideEnum } from '@toro/common/shared/enum/segment/segment-order-side.enum';
import { SegmentMarketTypeEnum } from '@toro/common/shared/enum/segment/segment-market-type.enum';
import { filter } from 'rxjs/operators';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { SuitabilityBypassAgreementActions } from '../../../../state-management/suitability-bypass-agreement/suitability-bypass-agreement.action';

@Component({
    selector: 'dialog-action-confirmation',
    templateUrl: './dialog-action-confirmation.component.html',
    styleUrls: ['../common/dialog-right.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
})
export class DialogActionConfirmationComponent extends DialogPanelComponentContent implements OnInit, OnDestroy {
    public form: FormGroup;
    public quoteValue: number;
    public busy: boolean = false;
    public searchTypeOptions: any[] = [
        {item: 'melhor preço disponível', value: 0},
        {item: 'preço personalizado', value: 1},
    ];

    public get isFuture(): boolean {
        return this.data.marketType === OrderMarketTypeEnum.Future;
    }

    public get isFractionated() {
        return !Number.isInteger(this.data.amount / this.data.standardLot);
    }

    public get investmentStep(): number {
        if (this.isFractionated) {
            return 1;
        } else {
            return this.data.standardLot;
        }
    }
    public dialogComponentReference: MatDialogRef<InvestmentResumeComponent>;
    public order: any;
    public scenarioSettings: CheckoutScenarioSettings = new CheckoutScenarioSettings();
    public hasBypassedSuitabilityForCurrentInvestment = false;
    private investmentType: any;
    private cblc: number = 0;
    private suitability: string = '';
    private disposableSubscriptions = new Array<Subscription>();
    

    constructor(
        public element: ElementRef,
        private billingEffects: BillingEffects,
        private dialogReference: MatDialogRef<DialogActionConfirmationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogActionConfirmation,
        private formBuilder: FormBuilder,
        private dialogsService: DialogsService,
        private store: Store<AppState>,
        private authorizationWraper: AuthorizationWraperService,
        private stocksExchangeCheckoutEffects: StocksExchangeCheckoutEffects,
        private interactions: StocksMarketInteractionsService,
        private toastrService: ToastrService,
    ) {
        super(element, true);

        this.form = formBuilder.group({
            stocksCount: [ this.investmentStep, Validators.required],
            customPrice: 0,
            searchType: 0,
        });
    }

    public ngOnInit() {
        super.ngOnInit();

        this.bindFormValueChangesSubscription();

        this.bindStoresSubscription();

        this.bindMainDispatches();        
    }

    /**
     * Método para englobar subscrições nas stores
     */
    public bindStoresSubscription() {
        this.bindQuoteSubscription();
        this.bindNewOrderEventsSubscription();
        this.bindBillingSubscription();
        this.bindAuthSubscription();
        this.bindSuitabilitySubscription();
    }

    /**
     * Método para englobar subscrições de value changes do formulário
     */
    public bindFormValueChangesSubscription() {
        const customPriceControl = this.form.get('customPrice');
        const searchTypeControls = this.form.get('searchType');
        // searchTypeControls.setValue(0);

        // adiciona/remove validação do campo personalizado quando o tipo de preço é alterado
        searchTypeControls.valueChanges.subscribe((value) => {
            if (value === 1) {
                if (customPriceControl.value === 0) {
                    customPriceControl.setValue(this.quoteValue);
                }
                customPriceControl.setValidators([Validators.required]);
            } else {
                customPriceControl.setValidators(null);
            }
            this.form.updateValueAndValidity();
        });
    }

    /**
     * Subscrição à quote store
     */
    public bindQuoteSubscription() {
        this.disposableSubscriptions.push(
            this.store.select((stocksExchangeStore) => stocksExchangeStore.stocksExchange.stocksMarket.quote)
                .filter((quote) => quote[this.data.symbol])
                .subscribe((quote) => {
                    const currentQuotation = quote[this.data.symbol];
                    this.quoteValue =
                        currentQuotation.PriceLastTrade || currentQuotation.OpeningPrice || currentQuotation.ClosingPricePreviousDay;
                }),
        );
    }

    
    /**
     * Subscrição à stocksEchangeCheckout store
     */
    public bindNewOrderEventsSubscription() {
        this.disposableSubscriptions.push(
            this.stocksExchangeCheckoutEffects.newOrder$
                .subscribe((action) => {
                    if (action.type.equals(StocksExchangeCheckoutAction.newOrderSuccess)) {
                        this.confirmSuccessAction();
                        this.orderSentDispatch();
                    }
                    if (action.type.equals(StocksExchangeCheckoutAction.newOrderError)) {
                        this.store.dispatch({ type: ApplicationMessagesAction.genericError, payload: action.payload });
                        this.busy = false;
                    }
                }),
        );
    }

    

    /**
     * Subscrição ao billing store
     */
    public bindBillingSubscription() {
        this.disposableSubscriptions.push(
            this.billingEffects.getBrokerageTax$
                .subscribe((action) => {
                    this.showAsideConfirmation(
                        (action.payload.brokerageValue === 0 || action.payload.brokerageValue) ? action.payload.brokerageValue : null,
                    );
                }),
        );
    }

    
    /**
     * Subscrição ao authentication store
     */
    public bindAuthSubscription(){
        // Pega o CBLC do usuário
        this.disposableSubscriptions.push(
            this.store.select((state) => state.authentication.currentUser)
                .pipe(
                    filter((result) => !!result)
                )
                .subscribe((currentUser) => {
                    this.cblc = currentUser.cblc;
                }),
        );
    }

    /**
     * Subscrição ao suitability store
     */
    public bindSuitabilitySubscription() {
        this.disposableSubscriptions.push(
            this.store.select((state) => state.suitability)
                .filter((result) => !!(result && result.profile))
                .subscribe((result) => {
                    this.suitability = result.profile.description;
                }),
                this.store.select(state => state['suitabilityBypassAgreement'])
                .filter(data => !!data)
                .subscribe(data => {
                    this.hasBypassedSuitabilityForCurrentInvestment = this.isFuture
                        ? data.suitabilityBypassAgreement.bmfAccepted
                        : data.suitabilityBypassAgreement.bovespaAccepted
                })
        );
    }

    public bindMainDispatches() {
        this.store.dispatch({ type: StocksMarketAction.getQuote, payload:  this.data.symbol});
    }

    /** Finaliza o componente */
    public dispose() {
        super.close(this.dialogReference, null);
    }

    public ngOnDestroy() {
        this.disposableSubscriptions.forEach((subscription) => {
            if (subscription) subscription.unsubscribe();
        });
    }

    /**
     * Método de submissão do formulário
     * @param event 
     */
    public onSubmit(event: Event) {
        event.preventDefault();
        this.busy = true;

        this._suitabilityBypass();
        this.order = this.composeOrderOrder();

        const obj = {
            isDaytrade: false,
            orderQty: this.order.orderQty,
            platform: BrokeragePlatform.Hub,
            price: this.order.price,
            symbol: this.order.symbol,
        };

        this.store.dispatch({ type: BillingAction.getBrokerageTax, payload: obj });
    }

    public orderSentDispatch() {
        // Dispatch que é feito pro Segment
        const event = new OrderSentEvent(
            SegmentCheckoutTypeEnum.NOT_PLANNED,
            this.data.symbol,
            TrackOriginEnum.INVESTMENT_PORTFOLIO,
            this.data.buy ? SegmentOrderSideEnum.BUY : SegmentOrderSideEnum.SELL,
            SegmentMarketTypeEnum.BOVESPA,
            this.form.get('stocksCount').value,
            this.cblc,
            this.suitability,
            false,
            'Old',
            null,
            this.form.get('searchType').value ? 'Custom Price' : 'Best Price',
            null,
            null,
            null,
            this.isFractionated,
            window['toroJWTMobile'],
            this.hasBypassedSuitabilityForCurrentInvestment,
        );

        this.store.dispatch({
            type: TrackingActions.sendOrderInformation,
            payload: event,
        });
    }

    /** Cria uma ordem baseada nos dados fornecidos pelo cliente */
    public composeOrderOrder() {

        // tslint:disable-next-line: prefer-const
        let order = new StockOrderType();

        order.symbol = this.isFractionated ? this.data.symbol + 'F' : this.data.symbol;
        order.orderQty = this.form.get('stocksCount').value;
        order.isDaytrade = this.data.daytrade;

        // Preço personalizado
        if (this.form.controls.searchType.value === 1) {
            order.price = this.form.controls.customPrice.value;
            order.priceType = StrategyRequestLegPriceType.Limited;
        } else {
            // a mercado
            order.priceType = StrategyRequestLegPriceType.Market;
        }
        // venda ou compra
        order.side = (this.data.buy) ? OrderSideEnum.Compra : OrderSideEnum.Venda;
        // day trade
        order.validityType = StrategyRequestLegValidityType.Day;
        order.internalOrderType =  StrategyRequestOrderType.Input;
        order.suitabilityNonConformityConsent = this.hasBypassedSuitabilityForCurrentInvestment;

        return order;
    }

    /** Exibe o resumo do investimento para que o usuário confirme os dados */
    public showAsideConfirmation(brokerageTax: number) {
        // this.pending = true;

        const obj = {
            investmentValue: this.order.orderQty * this.quoteValue,
            isDayTrade: false,
            usingWarranty: false,
            warrantyValue: this.data.availableValueToInvest,
            planned: false,
            incompatibleProfile: this.scenarioSettings.incompatibleProfile,
            purchase: this.scenarioSettings.purchase,
            unlocked: true,
            isFuture: this.isFuture,
            brokerage: brokerageTax,
            brokerageFactor: this.order.symbol.brokerageFactor,
        };

        this.dialogComponentReference =
            (this.dialogsService.showComponentAsAsidePanel(InvestmentResumeComponent, true, obj) as MatDialogRef<InvestmentResumeComponent>);

        this.disposableSubscriptions.push(
            this.dialogComponentReference.componentInstance.sendInvestmentSubject
                .subscribe((item) => {
                    if (item) {
                        this.store.dispatch({ type: StocksExchangeCheckoutAction.newOrder, payload: { data: this.order } });
                        this.dialogComponentReference.close();
                        this.dialogComponentReference = null;
                    }
                }),
        );

        this.disposableSubscriptions.push(
            this.dialogComponentReference.afterClosed()
                .subscribe(() => {
                    this.dialogComponentReference = null;
                    this.busy = false;
                })
        )
    }

    private _suitabilityBypass() {
        if (!this.hasBypassedSuitabilityForCurrentInvestment) {
            this.store.dispatch({ type: SuitabilityBypassAgreementActions.updateSuitabilityBypassAgreement, payload: { data: { "marketType": this.isFuture ? "Future" : "Bovespa" } } });
            this.hasBypassedSuitabilityForCurrentInvestment = true;
        }
    }

    /**
     * Abre o overlay de sucesso, se de ativo for vendido
     */
    private confirmSuccessAction() {
        this.dispose();
        if (this.data.marketOpen) {
            this.toastrService
                .success('A sua ordem de compra foi registrada com sucesso. Você pode acompanhar e conferir se este investimento foi efetivado na área Meus Investimentos', '', {
                    timeOut: 7000,
                    progressBar: true,
                    positionClass: 'toast-bottom-center',
                    toastClass: 'toast--default font-small--medium font-light-color',
                })
        } else {
            this.toastrService
                .warning(`A sua ordem de ${this.data.buy ? 'compra' : 'venda'} foi agendada com sucesso e será processada a partir das ${this.data.marketOpeningTime}h do próximo dia útil. Você pode acompanhar e conferir se este investimento foi efetivado na área Meus Investimentos.`,
                '', {
                    timeOut: 7000,
                    progressBar: true,
                    positionClass: 'toast-bottom-center',
                    toastClass: 'toast--default font-small--medium font-light-color',
                },);
        }
    }
}
